const baseColumnDefs = [
  {
    headerName: 'SecurityId',
    field: 'securityId',
    width: 100,
  },
  {
    headerName: 'Name',
    field: 'securityCode',
    width: 380,
    tooltipField: 'securityCode',
  },
  { headerName: 'Asset Class', field: 'assetClass', width: 100 },
  { headerName: 'Inst Class', field: 'instrumentClass', width: 100 },
  {
    headerName: 'Exchange',
    field: 'exchangeCode',
    width: 220,
    tooltipField: 'exchangeCode',
  },
  {
    headerName: 'BB_TCM',
    field: 'ticker',
    width: 220,
    tooltipField: 'ticker',
  },
  { headerName: 'Currency', field: 'pnlCcyCode', width: 100 },
  {
    headerName: 'Identifiers',
    field: 'identifiers',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      editButton: 'Identifiers',
    },
  },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      editButton: 'Edit',
    },
  },
]

const buildBasketIndexColumnDefs = ({ onIdentifiers, onEdit }) =>
  baseColumnDefs.map((col) => {
    if (col.field === 'identifiers') {
      return {
        ...col,
        cellRendererParams: {
          ...col.cellRendererParams,
          showEditModal: onIdentifiers,
        },
      }
    }
    if (col.field === 'edit') {
      return {
        ...col,
        cellRendererParams: {
          ...col.cellRendererParams,
          showEditModal: onEdit,
        },
      }
    }
    return col
  })

export { baseColumnDefs, buildBasketIndexColumnDefs }
